<div class="position-fixed card-position">
  <div class="backdrop-blur" id="backdropdiv">
  </div>
  <div class="sub-modal" id="centermodal">


    <div class="text-center">
      <img src="../../../assets/ai-sourcing/modal-blur-illustration.png"
        style="width: 172px; height: 132px; margin-bottom: 16px;" alt="">
    </div>
    <div class="text-center">
      <p class="modalheader font-weight-600 f-14">This Job is Inactive</p>
      <p class="modalcontent f-14 font-weight-normal mb-3"> To continue sourcing, please increase your team’s active
        project slots or contact Admin to deactivate another active project and activate this one.</p>
      <div class="text-center">
        <button data-testid="auto-app-blurbackdrop-button-1" class="btn-trms-small" style="min-width: 140px;" (click)="!changeButtonText && notifyAdmin()">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showNotifySpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showNotifySpinner }">
            {{showNotifySpinner ? '' : !changeButtonText ? 'Notify Admin': 'Notified'}}
          </span>
        </button>
      </div>
    </div>

  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg" [innerHtml]="successMessage"></span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg" [innerHtml]="errorMessage"></span>
</ngb-alert>
